<template>
  <div>
    <div class="wraper" v-if="!isProjectLoading">
      <div class="container-fluid mycontainer-fluid">
        <slot name="header"></slot>
        <ProjectHeader
          :project="project"
          show-plan-link="showCalendar"
        ></ProjectHeader>
      </div>
      <div
        class="container-fluid mycontainer-fluid content"
        v-if="!showCalendar && !showPlan"
      >
        <div style="float: right;padding-top: 20px">
          <a
            class="btn btn-info"
            href="https://docs.bitrix24.site/"
            target="_blank"
            >Шаблоны документов</a
          >
        </div>
        <div
          style="display: flex; align-items: flex-start; gap: 20px; clear: both;"
        >
          <div class="content-progres" style="flex: 1; min-width: 0; margin-top: 0; padding-top: 0;">
            <p class="progres-name content-mb-14" style="margin-top: 0;">
              Процесс прохождения входной экспертизы
            </p>
            <div class="row myrow">
              <p class="progres-label">
                Загружено документов
                {{ documentConf.FILE_LOAD_INFO.FACT_LOAD }}/{{
                  documentConf.FILE_LOAD_INFO.NEED_LOAD
                }}
              </p>
              <div class="col-lg-4 col-md-6 mycol">
                <div class="progress progress-striped">
                  <div
                    class="progress-bar progress-bar-success"
                    role="progressbar"
                    :aria-valuenow="documentConf.FILE_LOAD_INFO.FACT_LOAD"
                    aria-valuemin="0"
                    :aria-valuemax="documentConf.FILE_LOAD_INFO.NEED_LOAD"
                    :style="{
                      width:
                        (100 / documentConf.FILE_LOAD_INFO.NEED_LOAD) *
                          documentConf.FILE_LOAD_INFO.FACT_LOAD +
                        '%'
                    }"
                  >
                    <span class="sr-only">90% Завершено (Успешно)</span>
                  </div>
                </div>
              </div>
              <div class="col-lg-8 col-md-6 mycol"></div>
            </div>
            <div class="row myrow">
              <p class="progres-label">
                Акцептовано документов
                {{ documentConf.FILE_ACCEPT_INFO.FACT_ACCEPT_YES }}/{{
                  documentConf.FILE_ACCEPT_INFO.NEED_ACCEPT
                }}
              </p>
              <div class="col-lg-4 col-md-6 mycol">
                <div class="progress progress-striped">
                  <div
                    class="progress-bar progress-bar-info"
                    role="progressbar"
                    :aria-valuenow="
                      documentConf.FILE_ACCEPT_INFO.FACT_ACCEPT_YES
                    "
                    aria-valuemin="0"
                    :aria-valuemax="documentConf.FILE_ACCEPT_INFO.NEED_ACCEPT"
                    :style="{
                      width:
                        (100 / documentConf.FILE_ACCEPT_INFO.NEED_ACCEPT) *
                          documentConf.FILE_ACCEPT_INFO.FACT_ACCEPT_YES +
                        '%'
                    }"
                  >
                    <span class="sr-only">30% Завершено (Информация)</span>
                  </div>
                </div>
              </div>
              <div class="col-lg-8 col-md-6 mycol"></div>
            </div>
          </div>

          <div
            class="form-group mycol controller-button"
            style="flex-shrink: 0; text-align: right; margin: 10px 0;"
          >
            <p><span>Приложения:</span></p>
            <a
              type="button"
              class="btn btn-primary"
              @click="getPrintTZDocxUrl"
              v-show="showBtnGetPrintTZDocxUrl() === true"
            >
              {{ getNameApplicationTZ() }}
            </a>
            &nbsp;
            <a
              type="button"
              class="btn btn-primary"
              @click="getPrintBudgetDocxUrl"
              v-show="showBtnGetPrintBudgetDocxUrl() === true"
            >
              Смета расходования средств
            </a>
            &nbsp;
            <a
              type="button"
              class="btn btn-primary"
              @click="getPrintPlanDocxUrl"
              v-show="showBtnGetPrintKPUrl() === true"
            >
              Календарный план Проекта
            </a>
            &nbsp;
            <a
              type="button"
              class="btn btn-primary"
              @click="getPrintIndicatorsDocxUrl"
            >
              Целевые показатели
            </a>
          </div>
        </div>

        <div v-if="isDocsLoading" style="padding: 30px; text-align: center; color: #888;">
          Загрузка документов...
        </div>
        <div v-else-if="renderedCount < documentConf.LIST_TYPE.length && documentConf.LIST_TYPE.length > 0"
             style="padding: 10px 0; color: #888; font-size: 13px;">
          Отображено {{ renderedCount }} из {{ documentConf.LIST_TYPE.length }} разделов...
        </div>

        <div v-for="(ltItem, index) in visibleListType">
          <div
            class="content-title"
            style="display: flex; align-items: center;"
          >
            {{ index + 1 }}. {{ ltItem.SECTION_NAME }}

            <VDropdown
              v-if="ltItem.SECTION_HELP != ''"
              tag="span"
              trigger="click"
              placement="bottom"
              popperClass="custom-popper"
              style="display: inline"
            >
              <a class="icon-help-blue">
                &nbsp;
              </a>
              <template #popper>
                <div class="custom-popper-content">
                  {{ ltItem.SECTION_HELP }}
                </div>
              </template>
            </VDropdown>
          </div>
          <div v-if="ltItem.TYPE_LIST_ID">
            <DocumentTable
              :project="project"
              :index="index + 1"
              :docs="ltItem.TYPE_LIST_ID"
              :document-conf="documentConf"
              :document-history="documentHistory"
            ></DocumentTable>
          </div>
          <div v-if="ltItem.CHILD">
            <MultiDocumentTable
              :project="project"
              :index="index + 1"
              :childs="ltItem.CHILD"
              :document-conf="documentConf"
              :document-history="documentHistory"
            ></MultiDocumentTable>
          </div>
        </div>

        <div
          class="modal fade in show"
          v-if="documentHistory"
          tabindex="-1"
          role="dialog"
        >
          <div
            style="width: 1150px;z-index: 10000"
            class="modal-dialog"
            role="document"
          >
            <div class="modal-content">
              <div class="modal-header">
                <button
                  type="button"
                  class="close"
                  v-on:click="documentHistory = false"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
                <h4 class="modal-title">История изменения статуса документа</h4>
              </div>
              <div
                class="modal-body"
                style="
    overflow: scroll;
    max-height: 800px;
"
              >
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th>Версия документа</th>
                      <th>Документ</th>
                      <th>Дата загрузки документа</th>
                      <th></th>
                      <th>ЭЦП</th>
                      <th>Подписант</th>
                      <th>Дата действия</th>
                      <th>Сотрудник</th>
                      <th>Тип действия</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="item in documentHistory"
                      v-bind:class="{
                        'document-file-delete': item.UF_IS_DELETE
                      }"
                    >
                      <td>{{ item.VERSION }}</td>
                      <td>
                        <a
                          :href="siteUrl + item.FILE"
                          class="doc-link"
                          target="blank"
                          >{{ getFileName(item.FILE) }}</a
                        >
                      </td>
                      <td>{{ item.UF_DATE_UPDATE }}</td>
                      <!-- эцп -->
                      <td style="white-space: nowrap;" v-if="item.IS_SET_ECP">
                        <div class="doc-Y" v-if="item.UF_IS_SIGN_ECP"></div>
                        <div class="doc-N" v-else></div>
                      </td>
                      <td v-else></td>
                      <!-- modal ECP -->
                      <td
                        style="white-space: nowrap; text-decoration-line: none !important"
                        v-if="item.IS_SET_ECP"
                      >
                        <i
                          class="esd-data esd_icon"
                          @click="getECPHistoryInfo(item.ID)"
                          style="margin-right: 25px"
                        >
                          ЭЦП
                          <img src="/images/i-eds.png" />
                        </i>
                        <div class="esd-data">
                          <div
                            class="esd-data__info_history"
                            v-show="resultECP[item.ID]"
                          >
                            <div class="esd-close" @click="closeECP(item.ID)">
                              <i class="esd_exit"></i>
                            </div>
                            <div v-if="resultECP[item.ID]">
                              <p class="text-center">
                                Подлинник электронного документа, подписанного
                                ЭЦП,
                                <br />хранится в информационной системе “Личный
                                кабинет заемщика” <br />Фонда развития
                                промышленности
                              </p>
                              <h3 class="esd-title">
                                Сведения о сертификате ЭП
                              </h3>
                              <div class="container-fluid">
                                <div class="row">
                                  <div class="col-xs-4 col-md-4 stl-col-pb-8">
                                    Сертификат:
                                  </div>
                                  <div
                                    class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn esd_wsn"
                                  >
                                    {{ result[item.ID].SERTIFICATE_NUMBER }}
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-xs-4 col-md-4 stl-col-pb-8">
                                    Кем выдан:
                                  </div>
                                  <div
                                    class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn"
                                  >
                                    {{ result[item.ID].ISSUER }}
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-xs-4 col-md-4 stl-col-pb-8">
                                    Организация:
                                  </div>
                                  <div
                                    class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn"
                                  >
                                    {{ result[item.ID].COMPANY }}
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-xs-4 col-md-4 stl-col-pb-8">
                                    Кому выдан:
                                  </div>
                                  <div
                                    class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn"
                                  >
                                    {{ result[item.ID].OWNER_FIO }}
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-xs-4 col-md-4 stl-col-pb-8">
                                    Действителен:
                                  </div>
                                  <div
                                    class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn"
                                  >
                                    {{ result[item.ID].DATE_USE_SERTIFICATE }}
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-xs-4 col-md-4 stl-col-pb-8">
                                    Название документа:
                                  </div>
                                  <div
                                    class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn"
                                  >
                                    {{ result[item.ID].FILE_NAME }}
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-xs-4 col-md-4 stl-col-pb-8">
                                    Дата загрузки:
                                  </div>
                                  <div
                                    class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn"
                                  >
                                    {{ result[item.ID].FILE_DATE_LOAD }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td v-else></td>
                      <td style="white-space: nowrap;" v-if="item.IS_SET_ECP">
                        <div>
                          {{ item.UF_FILE_SIGN_AUTHOR }}
                        </div>
                      </td>
                      <td v-else></td>
                      <td>{{ item.UF_DATE_AKCEPT }}</td>
                      <td>{{ item.UF_MANAGER_AKCEPT_NAME }}</td>
                      <td>{{ item.UF_IS_AKCEPT }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-default"
                  data-dismiss="modal"
                  v-on:click="documentHistory = false"
                >
                  Закрыть
                </button>
              </div>
            </div>
            <!-- /.modal-content -->
          </div>
          <!-- /.modal-dialog -->
        </div>
        <!-- /.modal -->
      </div>
      <Calendar v-else-if="showCalendar"></Calendar>
      <div>
        <component
          :project="project"
          v-bind:is="getPlan"
          v-if="showPlan"
        ></component>
      </div>
      <ChangeStatusDialog v-if="showChangeStatusDialog"></ChangeStatusDialog>
      <ChangeManagerDialog v-if="showChangeManagerDialog"></ChangeManagerDialog>
      <br />
      <br />
      <br />
      <br />
    </div>
    <div class="wraper" v-else>
      <h3>Загрузка документов проекта...</h3>
    </div>
    <div class="footer footer-fix">
      <div class="container-fluid mycontainer-fluid">
        <div class="footer-sabmit" v-show="!isLoading && !showPlan">
          <template v-if="currentUser.TYPE_USER === 'manager'">
            <!--<button
            v-if="currentUser.TYPE_USER === 'manager'"
            v-show="isChangeStatus"
            style="width: auto;"
            class="but-style but-push"
            v-on:click="showChangeStatusDialog = true"
          >
            Изменить статус
          </button>-->
          </template>
          <!--<button
            v-else-if="
              statuses.length > 0 && isChangeStatus && isChangeStatusAvailable
            "
            style="width: auto;"
            class="but-style but-push"
            @click="sendToStatus(statuses[0].ID)"
          >
            Отправить проект на статус "{{ statuses[0].NAME }}"
          </button>-->
          <button
            v-show="isChangeManager"
            style="width: auto;"
            class="but-style but-push"
            v-on:click="showChangeManagerDialog = true"
          >
            {{ project.UF_MANAGER_ID > 0 ? "Изменить" : "Назначить" }} менеджера
          </button>
          <a
            style="padding: 2px 12px;"
            href="#"
            class="btn btn-default"
            @click="getLinkFileArhive"
            v-show="viewArchiveBtn"
            >Скачать одним архивом</a
          >
          <a
            style="padding: 2px 12px;"
            href="#"
            class="btn btn-default"
            v-show="viewArchiveExpertiseBtn"
            @click="getLinkFileArhiveAndExpertises"
            >Скачать одним архивом (+экспертизы)</a
          >
          <a
            style="padding: 2px 12px;"
            class="btn btn-default"
            @click="getLinkFileDownloadUploadES"
            v-show="IS_DOWNLOAD_UPLOAD_ES === 1"
            target="_blank"
            >Выгрузка для ЭС</a
          >
        </div>
        <div class="footer-sabmit" v-show="showSaveEquipment && showPlan">
          <template
            v-if="
              project.UF_SETTING && project.UF_SETTING.IS_EQUIPMENT_ACCEPT !== 1"
          >
            <button
              style="width: auto;"
              class="but-style but-push"
              @click="saveProject"
            >
              Сохранить
            </button>
            <a
              style="padding: 2px 12px; margin-top: -1px;"
              class="btn btn-default"
              @click="hidePlan"
            >
              Отмена
            </a>
          </template>

          <!--<template v-if="isViewAcceptButton">
            &nbsp;&nbsp;&nbsp;
            <button
              v-if="
                project.UF_SETTING &&
                  project.UF_SETTING.IS_EQUIPMENT_ACCEPT !== 1
              "
              class="but-style btn-success"
              style="width: 300px; padding: 0;"
              @click="changeAcceptEquipment(1)"
            >
              Акцептовать список закупаемого
            </button>
            <button
              v-else
              class="but-style btn-danger"
              style="width: 300px"
              @click="changeAcceptEquipment(0)"
            >
              Вернуть список закупаемого в работу
            </button>
          </template>-->
        </div>
        <div class="myfooter">
          <div class="myfooter-frp"></div>
        </div>
      </div>
    </div>
    <project-menu></project-menu>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  FETCH_PROJECT,
  FETCH_DIRECTORY,
  FETCH_CALENDAR_PLAN,
  SAVE_PROJECT,
  SET_IS_VIEW_ALL_EXPERTISE
} from "@/store/actions.type";
import { AUTH_URL } from "@/common/config";
import { ProjectsService } from "@/common/api.service";
import SendProjectDialog from "@/components/project/form/SendProjectDialog";
import ChangeStatusDialog from "@/components/project/form/ChangeStatusDialog";
import ChangeManagerDialog from "@/components/project/form/ChangeManagerDialog";
import ProjectHeader from "@/components/project/partial/ProjectHeader";
import DocumentTable from "@/components/project/documents/DocumentTable";
import MultiDocumentTable from "@/components/project/documents/MultiDocumentTable";
import Calendar from "@/components/project/documents/Calendar";
import ProjectMenu from "@/components/project/partial/ProjectMenu";
import Vue from "vue";

export default {
  title: "Документы проекта",
  name: "ProjectDocuments",
  data() {
    return {
      IS_DOWNLOAD_UPLOAD_ES: null,
      siteUrl: "",
      statuses: [],
      rerender: true,
      documentConf: {
        FILE_ACCEPT_INFO: {
          NEED_ACCEPT: 1,
          FACT_ACCEPT: 0,
          FACT_ACCEPT_YES: 0,
          FACT_ACCEPT_NO: 0
        },
        LIST_TYPE: [],
        FILE_DOCUMENTS_PATH: {},
        FILE_DOCUMENTS_SETTING: {},
        FILE_LIST_TYPE_ID: [],
        FILE_LOAD_INFO: { NEED_LOAD: 1, FACT_LOAD: 0 }
      },
      showDocumentHistory: false,
      documentHistory: false,
      showCalendar: false,
      showPlan: false,
      showSaveEquipment: false,
      isChangeStatus: false,
      isChangeManager: false,
      showChangeStatusDialog: false,
      showChangeManagerDialog: false,
      viewArchiveBtn: false,
      viewArchiveExpertiseBtn: false,
      calendarYears: {
        yearStart: 0,
        yearsEnd: 0
      },
      result: {},
      resultECP: {},
      isViewAcceptButton: false,
      renderedCount: 0,
      isDocsLoading: true
    };
  },
  components: {
    ProjectMenu,
    Calendar,
    MultiDocumentTable,
    DocumentTable,
    ProjectHeader,
    SendProjectDialog,
    ChangeStatusDialog,
    ChangeManagerDialog
  },
  watch: {},
  methods: {
    renderNextSection() {
      const total = this.documentConf.LIST_TYPE.length;
      if (this.renderedCount < total) {
        this.renderedCount = Math.min(this.renderedCount + 1, total);
        setTimeout(() => this.renderNextSection(), 0);
      }
    },
    getProgramCode() {
      let t = this.directory.program_fin_support.filter(
        c => c.ID === this.project.UF_SUPPORT_PROG_ID
      );
      if (t.length > 0) {
        return t[0].CODE;
      }
      return "";
    },
    async saveProject() {
      this.tosterErrors = [];
      this.project.IS_SAVE_EQUPMENT = 1;
      const s = await this.$store
        .dispatch(SAVE_PROJECT, this.project)
        .then(() => {
          if (this.saveProjectSaved) {
            this.fetchProject(7);
          }
          let showErrors = false;
          if (this.saveProjectErrors.length > 0) {
            this.saveProjectErrors.forEach(function(err) {
              if (
                err.MODEL === "EQUIPMENT_ZAIM" ||
                err.MODEL === "PURCHASED_EQUIPMENT" ||
                err.MODEL === "PURCHASED_EQUIPMENT" ||
                err.MODEL === "EQUIPMENT_COMPONENTS_MATERIALS" ||
                err.MODEL === "EQUIPMENT_INDUSTRIAL" ||
                err.MODEL === "EQUIPMENT_BUY_LIZING" ||
                err.MODEL === "EQUIPMENT_LICENSES_PATENTS" ||
                err.MODEL === "EQUIPMENT_LICENSES_PATENTS_MARKIROVKA" ||
                err.MODEL === "EQUIPMENT_LICENSES_PATENTS_MARKIROVKA"
              ) {
                showErrors = true;
                this.tosterErrors[
                  this.tosterErrors.length
                ] = this.$toasted.show(err.TEXT, {
                  theme: "bubble",
                  position: "bottom-right",
                  duration: null,
                  action: [
                    {
                      text: "Закрыть",
                      onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                      }
                    },
                    {
                      text: "Закрыть все",
                      onClick: () => {
                        this.tosterErrors.forEach(function(err) {
                          err.goAway(0);
                        });
                      }
                    }
                  ]
                });
              }
            }, this);
          }

          if (!showErrors) {
            this.$toasted.show("Раздел проекта успешно сохранен", {
              theme: "green",
              position: "bottom-right",
              duration: 3500
            });
          }

          return true;
        });
      return s;
    },
    async hidePlan() {
      this.$router.push({
        name: "ProjectDocuments",
        params: { id: this.$route.params.id }
      });
      this.showPlan = false;
      await this.fetchProject(7);
    },
    getLinkFileDownloadUploadES() {
      ProjectsService.getLinkFileDownloadUploadES(this.project.ID)
        .then(({ data }) => {
          window.location.href =
            AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link;
        })
        .catch(err => console.log("getLinkFileDownloadUploadES", err));
    },
    async getManagerRoleDefaultSetting() {
      await ProjectsService.getManagerRoleDefaultSetting(
        this.project.UF_STATUS_ID
      ).then(({ data }) => {
        this.$store.dispatch(
          SET_IS_VIEW_ALL_EXPERTISE,
          data.IS_VIEW_ALL_EXPERTISE
        );
        if (data.IS_DOWNLOAD_UPLOAD_ES) {
          this.IS_DOWNLOAD_UPLOAD_ES = data.IS_DOWNLOAD_UPLOAD_ES;
        }
      });
    },
    sendToStatus(id) {
      ProjectsService.setNewStatusProject(this.project.ID, {
        UF_STATUS_ID: id
      }).then(response => {
        if (response.data.error === false) {
          this.isChangeStatus = false;
          //this.fetchProject();
          this.$router.push({ name: "Projects" });
        } else {
          response.data.errorArr.forEach(function(text) {
            this.$toasted.show(text, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
        }
      }, this);
    },
    async fetchProject() {
      const projectPromise = this.$store.dispatch(FETCH_PROJECT, this.$route.params.id);

      // Начинаем рендер документов сразу как они пришли, не ждём FETCH_PROJECT
      const { data: docData } = await ProjectsService.getDocumentESProjects(this.$route.params.id);
      // Freezing non-mutable parts prevents Vue 2 from recursively adding reactivity to them
      if (docData.FILE_DOCUMENTS_SETTING) Object.freeze(docData.FILE_DOCUMENTS_SETTING);
      if (docData.FILE_LIST_TYPE_ID) Object.freeze(docData.FILE_LIST_TYPE_ID);
      this.documentConf = docData;
      this.isDocsLoading = false;
      this.renderedCount = 0;
      setTimeout(() => this.renderNextSection(), 0);

      // Ждём загрузки проекта для следующих вызовов
      await projectPromise;

      await Promise.all([
        this.getManagerRoleDefaultSetting(),
        ProjectsService.getRulesChangeStatusUser(this.project.UF_STATUS_ID).then(({ data }) => {
          this.viewArchiveBtn = data.IS_VIEW_BUT_ARHIVE_DOC;
          this.viewArchiveExpertiseBtn = data.IS_VIEW_BUT_ARHIVE_DOC_EXPERTISE;

          if (data.IS_CHANGE_STATUS && data.RAZDEL_CHANGE === "DOCUMENTS") {
            this.isChangeManager = data.IS_CHANGE_MANAGER;
            this.directory.program_fin_support.forEach(async function(s) {
              this.showSubmitBtn = false;
              if (s.ID === this.project.UF_SUPPORT_PROG_ID) {
                this.statuses = [];
                ProjectsService.bpStatus(
                  s.UF_BP_ID,
                  this.project.UF_STATUS_ID
                ).then(({ data }) => {
                  Object.keys(data[0].PREV_STATUS_ID).forEach(function(k) {
                    this.directory.status.forEach(function(item) {
                      if (item.ID === data[0].PREV_STATUS_ID[k]) {
                        this.statuses.push(item);
                      }
                    }, this);
                  }, this);

                  Object.keys(data[0].NEXT_STATUS_ID).forEach(function(k) {
                    this.directory.status.forEach(function(item) {
                      if (item.ID === data[0].NEXT_STATUS_ID[k]) {
                        this.statuses.push(item);
                      }
                    }, this);
                  }, this);

                  if (Object.keys(this.statuses).length) {
                    this.isChangeStatus = true;
                  }
                }, this);
              }
            }, this);
          }

          //task 31867
          if (
            this.project.UF_IS_SET_MANAGER_RULES &&
            this.currentUser.ACTIVE_ROLE_CODE == "manager1" &&
            this.project.UF_STATUS_ID == 273
          ) {
            this.isChangeManager = 1;
          }
        }, this)
      ]);
    },
    getFileName(file) {
      let p = file.split("/");
      return p[p.length - 1];
    },
    loadCalendar() {
      if (this.$route.params.page !== "tasks-targets") {
        this.$router.push({
          name: "ProjectDocumentsPlan",
          params: { id: this.$route.params.id, page: "tasks-targets" }
        });
      }
      this.$store
        .dispatch(FETCH_CALENDAR_PLAN, this.$route.params.id)
        .then(() => {
          this.showCalendar = true;
        }, this);
    },
    hideCalendar() {
      this.$router.push({
        name: "ProjectDocuments",
        params: { id: this.$route.params.id }
      });
      this.showCalendar = false;
    },
    loadPlan() {
      if (this.$route.params.page !== "purchased-list") {
        this.$router.push({
          name: "ProjectDocumentsPlan",
          params: { id: this.$route.params.id, page: "purchased-list" }
        });
      }
      this.showPlan = true;
    },
    getLinkFileArhive() {
      ProjectsService.getLinkFileArhive(this.project.ID).then(({ data }) => {
        window.location.href =
          AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link;
      });
    },
    getLinkFileArhiveAndExpertises() {
      ProjectsService.getLinkFileArhiveAndExpertises(this.project.ID).then(
        ({ data }) => {
          window.location.href =
            AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link;
        }
      );
    },
    getPrintTZDocxUrl() {
      ProjectsService.getPrintTZDocxUrl(this.project.ID).then(({ data }) => {
        window.location.href =
          AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link;
      });
    },
    getPrintBudgetDocxUrl() {
      ProjectsService.getPrintBudgetDocxUrl(this.project.ID).then(
        ({ data }) => {
          window.location.href =
            AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link;
        }
      );
    },
    getPrintPlanDocxUrl() {
      ProjectsService.getPrintPlanDocxUrl(this.project.ID).then(({ data }) => {
        window.location.href =
          AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link;
      });
    },
    getPrintIndicatorsDocxUrl() {
      ProjectsService.getPrintIndicatorsDocxUrl(this.project.ID).then(
        ({ data }) => {
          window.location.href =
            AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link;
        }
      );
    },
    showBtnGetPrintTZDocxUrl() {
      return true;
    },
    getNameApplicationTZ() {
      let nameApplicationTZ = "Техническое задание";
      if (this.getProgramCode() === "lizing") {
        nameApplicationTZ = "Спецификация на промышленное оборудование";
      } else if (this.getProgramCode() === "component_and_resource_base") {
        nameApplicationTZ = "Основные характеристики проекта";
      }
      return nameApplicationTZ;
    },
    showBtnGetPrintBudgetDocxUrl() {
      if (
        this.getProgramCode() === "evolution" ||
        this.getProgramCode() === "regfond" ||
        this.getProgramCode() === "complectyushie" ||
        this.getProgramCode() === "complectyushie_rfrp" ||
        this.getProgramCode() === "epidemiological_control" ||
        this.getProgramCode() === "konversia" ||
        this.getProgramCode() === "working" ||
        this.getProgramCode() === "working_rfrp" ||
        this.getProgramCode() === "cifrovizaciya" ||
        this.getProgramCode() === "lekarstva" ||
        this.getProgramCode() === "stankostroi" ||
        this.getProgramCode() === "priority_program" ||
        this.getProgramCode() === "forestry_projects_rfrp" ||
        this.getProgramCode() === "component_and_resource_base" ||
        this.getProgramCode() === "improving_ecology" ||
        this.getProgramCode() === "transport_engineering" ||
        this.getProgramCode() === "auto_components" ||
        this.getProgramCode() === "providing_mobilization_needs"
      ) {
        return true;
      }
    },
    showBtnGetPrintKPUrl() {
      return !(
        this.getProgramCode() === "epidemiological_control" ||
        this.getProgramCode() === "component_and_resource_base" ||
        this.getProgramCode() === "providing_mobilization_needs"
      );
    },
    closeECP(idFile) {
      this.resultECP[idFile] = !this.resultECP[idFile];
    },
    getECPHistoryInfo(idFile) {
      if (this.result[idFile] !== undefined) {
        Vue.set(this.resultECP, [idFile], true);
      } else {
        ProjectsService.getECPInfoHistoryFile(this.project.ID, idFile).then(
          ({ data }) => {
            Vue.set(this.result, [idFile], data.result);
            Vue.set(this.resultECP, [idFile], true);
          }
        );
      }
    },
    changeAcceptEquipment(params) {
      ProjectsService.changeAcceptEquipment(this.project.ID, params).then(
        ({ data }) => {
          if (data.error) {
            data.errorArr.forEach(function(text) {
              this.$toasted.show(text.TEXT, {
                theme: "red",
                position: "bottom-right",
                duration: 3500
              });
            }, this);
            return;
          } else {
            this.$toasted.show(
              "Статус акцепта списка закупаемого успешно изменен",
              {
                theme: "green",
                position: "bottom-right",
                duration: 3000
              }
            );

            this.project.UF_SETTING.IS_EQUIPMENT_ACCEPT = params;
          }
        },
        this
      );
    }
  },
  computed: {
    visibleListType() {
      return this.documentConf.LIST_TYPE.slice(0, this.renderedCount);
    },
    isChangeStatusAvailable() {
      if (
        this.documentConf.FILE_LOAD_INFO.FACT_LOAD ===
        this.documentConf.FILE_LOAD_INFO.NEED_LOAD
      ) {
        return true;
      }
      return false;
    },
    getPlan: function() {
      let code = this.getProgramCode();
      if (typeof Vue.options.components[`step7${code}`] !== "undefined") {
        return Vue.options.components[`step7${code}`];
      } else {
        return Vue.options.components[`step7`];
      }
    },
    ...mapGetters([
      "project",
      "isLoading",
      "directory",
      "currentUser",
      "calendarItems",
      "saveProjectErrors",
      "isProjectLoading"
    ])
  },
  mounted() {
    if (this.currentUser.TYPE_USER === "manager") {
      ProjectsService.getManagerRoleDefaultSetting()
        .then(({ data }) => {
          this.isViewAcceptButton = parseInt(data.IS_ACCEPT_PLAN);
        }, this)
        .catch(err => console.log(err));
    }
  },
  async created() {
    this.siteUrl = AUTH_URL.replace(new RegExp("[\\/]+$"), "");
    await Promise.all([
      this.$store.dispatch(FETCH_DIRECTORY, ["status"]),
      this.$store.dispatch(FETCH_DIRECTORY, ["status_all"]),
      this.$store.dispatch(FETCH_DIRECTORY, ["tree/file_type2"]),
      this.$store.dispatch(FETCH_DIRECTORY, ["program_fin_support"])
    ]);
    this.fetchProject();
    if (this.$route.params.page === "tasks-targets") {
      this.loadCalendar();
    }
    if (this.$route.params.page === "purchased-list") {
      this.loadPlan();
    }
  }
};
</script>

<style scoped>
h3 {
  text-align: center;
  margin-top: 30px;
  margin-bottom: 20px;
}
</style>
